import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";

export const settingsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCms: builder.query({
      query: ({}) => ({
        url: `${END_POINTS.getVendorCms}`,
        method: "GET",
      }),
    }),

    setVendorTime: builder.mutation({
      query: (body) => ({
        url: END_POINTS.vendorTime,
        method: "POST",
        body,
      }),
    }),

    getAllFaq: builder.query({
      query: (body) => ({
        url: `${END_POINTS.allFaq}`,
        method: "POST",
        body,
      }),
    }),

    addFaq: builder.mutation({
      query: (body) => ({
        url: END_POINTS.addFaq,
        method: "POST",
        body,
      }),
    }),

    deleteFaq: builder.mutation({
      query: (id) => ({
        url: `${END_POINTS.deleteFaq}${id}/`,
        method: "DELETE",
      }),
    }),

    allSupport: builder.mutation({
      query: (body) => ({
        url: END_POINTS.allSupport,
        method: "POST",
        body,
      }),
    }),

    revertSupport: builder.mutation({
      query: ({ body, id }) => ({
        url: `${END_POINTS.revertSupport}${id}/`,
        method: "POST",
        body,
      }),
    }),

    getAdminCms: builder.query({
      query: ({}) => ({
        url: `${END_POINTS.adminCms}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLazyGetCmsQuery,
  useSetVendorTimeMutation,
  useLazyGetAllFaqQuery,
  useAddFaqMutation,
  useDeleteFaqMutation,
  useAllSupportMutation,
  useRevertSupportMutation,
  useLazyGetAdminCmsQuery,
} = settingsApi;
